const compare = (a, b, checkAllKeys = true) => {
  // only set checkAllKeys to false when you only wish to compare 
  // the values in a against thos in b. a should have the lesser
  // amount of keys
  try {
    if (checkAllKeys) {
      if (Object.keys(a).length !== Object.keys(b).length) throw "not equal";
      Object.keys(a).forEach(key => {
        if (a[key] !== b[key]) throw "not equal";
      });
      return true;
    }
    else {
      Object.keys(a).forEach(key => {
        if (a[key] !== b[key]) throw "not equal";
      });
      return true;
    }
  }
  catch {
    return false;
  }
}

export default compare;